import KListTileAvatar from "./KListTileAvatar";
import {
	VListItem,
	VListItemContent
} from "vuetify/lib";

export default {
	name: "KListTile",

	functional: true,

	props: {
		avatar: Boolean,
		identifier: [ Number, String ],
		text: String,
		to: Object
	},

	render( h, context ) {
		const showAvatar = context.props.avatar || context.props.avatar === "";

		return <VListItem
			attrs={context.data.attrs}
			key={context.props.identifier ? `${context.props.identifier}-list-tile` : `${context.props.text}-list-tile`}
			on={context.listeners}
			to={context.props.to}
		>
			{showAvatar && <KListTileAvatar text={context.props.text}></KListTileAvatar>}

			<VListItemContent>
				{context.props.text}
			</VListItemContent>
		</VListItem>;
	}
};
